import { render, staticRenderFns } from "./popup-sync.vue?vue&type=template&id=6087f8ce&scoped=true"
import script from "./popup-sync.vue?vue&type=script&lang=js"
export * from "./popup-sync.vue?vue&type=script&lang=js"
import style0 from "./popup-sync.vue?vue&type=style&index=0&id=6087f8ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6087f8ce",
  null
  
)

export default component.exports